import React, { FC, useState } from 'react';
import { SimpleOrderContext } from './simple-order-context';
import SimpleOrder from './simple-order.component';
import { currentUserVar } from 'apollo/reactive-variables/user';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import { permissions } from 'utils/permission';
import { CONSTANTS } from 'config/constants';
import Cookies from 'js-cookie';
import { LinkedClinic, LinkedUser } from 'models/order';
import { SimpleOrderInput } from 'models/order-input/simple-order';
import { OrderInputType } from 'models/order-input/shared';
import { Organization } from 'models/organization';

const { LAB_ID_KEY } = CONSTANTS;

const CreateSimpleOrder: FC = () => {
    const currentUser = currentUserVar();
    const currentOrg = currentOrgVar();
    const isWhiteLabeled = permissions.isWhiteLabeledOrganization(currentOrg);
    const defaultClinic = currentUser.systemSetting?.clinic?._id ? currentUser.systemSetting?.clinic : undefined;

    const [order, setOrder] = useState<SimpleOrderInput>({
        inputType: OrderInputType.NEW,
        isWhiteLabeled: permissions.isWhiteLabeledOrganization(currentOrg),
        supplier: {
            _id: isWhiteLabeled ? Cookies.get(LAB_ID_KEY) : undefined,
        } as Organization,
        customer: currentOrg,
        dentist: currentUser,
        restorations: [],
        participants: {
            linkedDentists: [] as LinkedUser[],
            linkedClinics: [] as LinkedClinic[],
            customParticipantEmails: [] as string[],
        },
        comment: '',
        historicalComments: [],
        files: [],
        sample: { type: '', content: [], otherContent: '' },
        deliveryDetails: {
            date: new Date(),
            time: {
                hour: undefined,
                minute: undefined,
            },
            pickUpLocation: defaultClinic,
            destination: defaultClinic,
        },
    } as SimpleOrderInput);

    return (
        <SimpleOrderContext.Provider value={{ order, setOrder }}>
            <SimpleOrder />
        </SimpleOrderContext.Provider>
    );
};

export default CreateSimpleOrder;
